import React, { useState, useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {
  createSubCategory,
  updateSubCategory,
  getSubCategory,
  deleteSubCategory,
  getCategory,
} from "../services/providerService";
import { useFormik } from "formik";
import * as Yup from "yup";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import Loader from "../../utils/Loader";
import reddelete from "../../images/red-Delete.svg";
import { apiUrl, PORT } from "../../environment";
import "./MediaManagment.css";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import { toast } from "react-toastify";

export default function SubCategoryListing() {
  const [searchText, setSearchText] = useState("");
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [show, setShow] = useState(false);
  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteModelShow, setDeleteModelShow] = useState(false);

  useEffect(() => {
    __getCategory();
    _getSubCategoryList();
  }, [page, limit]);

  const __getCategory = async () => {
    await getCategory({}, (data) => {
      setCategoryList(data || []);
    });
  };

  const _getSubCategoryList = async (
    sortBy,
    _category = "All",
    searchText = ""
  ) => {
    setLoading(true);
    await getSubCategory(
      {
        page: page + 1,
        limit,
        category: _category || "All",
        searchKey: searchText,
        sortBy: sortBy,
      },
      (data) => {
        setSubCategoryList(data.list || []);
        setTotalPages(data.totalPages);
        setTotalItems(data.totalItems);
        setLoading(false);
      }
    );
  };
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getSubCategoryList(selectedSortValue, category, query);
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedSortValue(eventKey);
    _getSubCategoryList(eventKey, category, searchText);
  };

  const handleCategorySelect = (category) => {
    setCategory(category);
    _getSubCategoryList(selectedSortValue, category, searchText);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Category is required"),
    subCategory: Yup.string().required("Sub Category is required"),
  });
  const formik = useFormik({
    initialValues: {
      _id: null,
      category: "Learn",
      subCategory: "",
      subCategoryIcon: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("category", values.category);
      formData.append("subCategory", values.subCategory);

      setLoading(true);
      if (values.subCategoryIcon) {
        formData.append("subCategoryIcon", values.subCategoryIcon);
      }

      try {
        let res;
        if (values._id) {
          res = await updateSubCategory(values._id, formData);
        } else {
          res = await createSubCategory(formData);
        }

        setShowViewModel(false);

        formik.setValues({
          _id: "",
          category: "Learn",
          subCategory: "",
          subCategoryIcon: null,
        });
        formik.resetForm();
        setPreviewImage(null);

        if (res.status === "SUCCESS") {
          _getSubCategoryList(selectedSortValue, category, searchText);
          toast.success(res.message);
          setShow(false);
          setShowViewModel(false);
        } else {
          toast.error(res.message);
          setShow(false);
        }

        setLoading(false);
      } catch (error) {
        toast.error("Failed!");
        setShow(false);
        setShowViewModel(false);
      }
    },
  });

  const createUpdateCateory = (categoryValue) => {
    formik.setValues({
      _id: categoryValue?._id || "",
      category: categoryValue?.category || "Learn",
      subCategory: categoryValue?.subCategory || "",
      subCategoryIcon: categoryValue?.subCategoryIcon || null,
    });
    setShowViewModel(true);
  };

  const handelDeleteModel = (categoryValue) => {
    formik.setValues({
      _id: categoryValue?._id || "",
      category: categoryValue?.category || "Learn",
      subCategory: categoryValue?.subCategory || "",
      subCategoryIcon: categoryValue?.subCategoryIcon || null,
    });
    setDeleteModelShow(true);
  };

  const _deleteCategory = async () => {
    await deleteSubCategory(formik.values._id);
    await _getSubCategoryList(selectedSortValue, category, searchText);
    setDeleteModelShow(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="add-doctor">
        <Form>
          <Form.Group controlId="searchInput">
            <Form.Control
              type="search"
              aria-label="Search"
              value={searchText}
              onChange={handleSearchChange}
              placeholder="Search  by category and sub category ..."
            />
          </Form.Group>
        </Form>

        <Button onClick={() => createUpdateCateory()} className="filled-btn">
          Create
        </Button>

        <Dropdown className="patient-info-dropdown " onSelect={handleSelect}>
          <Dropdown.Toggle className="db-dropdown h-100 ">
            {selectedSortValue === ""
              ? "Sort By"
              : selectedSortValue === "name-asc"
                ? "Name A-Z"
                : "Name Z-A"}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Default</Dropdown.Item>
            <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
            <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown
          className="patient-info-dropdown"
          onSelect={handleCategorySelect}
        >
          <Dropdown.Toggle className="db-dropdown h-100 ">
            {category === "" ? "Category" : category}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="All">All</Dropdown.Item>

            {categoryList?.map((category, index) => (
              <Dropdown.Item key={index} eventKey={category?.category}>
                {category?.category}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="table-responsive dashboard-table">
        <table className="patients-table">
          <thead>
            <tr className="t-row-block">
              <th scope="col">Sr No</th>
              <th scope="col">Category</th>
              <th scope="col">Sub-Category</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {subCategoryList?.length > 0 ? (
              subCategoryList?.map((cateory, index) => (
                <tr key={cateory.id || index}>
                  <td scope="row">{++index}</td>
                  <td>{cateory?.category ? cateory?.category : "-"}</td>
                  <td>{cateory?.category ? cateory?.subCategory : "-"}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <a
                        className="edit-del-icon eye-edit-del edit-img"
                        onClick={() => {
                          createUpdateCateory(cateory);
                        }}
                      >
                        <img src={editicon} alt="edit" />
                      </a>
                      <a
                        className="edit-del-icon eye-edit-del del-img"
                        onClick={() => handelDeleteModel(cateory)}
                      >
                        <img src={binicon} alt="delete" />
                      </a>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Category Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      {/* Modal to view survey   */}
      <Modal
        className="survey-model"
        show={showViewModel}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>Create Sub-Category </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form className="" onSubmit={formik.handleSubmit}>
            <div className="form-control-area ">
              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Category<span className="asterisk">*</span>
                </Form.Label>

                <Form.Select
                  className="selected-fields"
                  name="category"
                  keyField={"category"}
                  value={formik.values?.category}
                  onChange={(e) =>
                    formik.setFieldValue("category", e.target.value)
                  }
                  onBlur={formik.handleBlur}
                >
                  {categoryList?.map((category, index) => (
                    <option key={index} value={category?.category}>
                      {category?.category}
                    </option>
                  ))}
                </Form.Select>

                {formik.touched.category && formik.errors.category ? (
                  <div className="text-danger">{formik.errors.category}</div>
                ) : null}
              </Form.Group>

              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Sub Category<span className="asterisk"> *</span>
                </Form.Label>
                <div className="row">
                  <div className="col-12">
                    <Form.Control
                      type="text"
                      placeholder="Enter Sub Category"
                      name="subCategory"
                      keyField={"subCategory"}
                      formik={formik}
                      value={formik.values.subCategory}
                      onChange={(e) =>
                        formik.setFieldValue("subCategory", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />

                    {formik.touched.subCategory && formik.errors.subCategory ? (
                      <div className="text-danger">
                        {formik.errors.subCategory}
                      </div>
                    ) : null}
                  </div>
                </div>
              </Form.Group>

              {previewImage ? (
                <div className="mt-3">
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              ) : formik.values._id ? (
                <img
                  src={`${apiUrl}${PORT}/user-service/getimages/${formik.values.subCategoryIcon}`}
                  alt={`Preview ${formik.values.subCategoryIcon
                      ? formik.values.subCategoryIcon
                      : " Not Available"
                    }`}
                  className="file-preview-image"
                  style={{ maxWidth: "100px", marginRight: "10px" }}
                />
              ) : (
                <span>No image selected</span>
              )}

              { }
            </div>

            <div className=" = d-flex mt-2 gap-4 justify-content-end">
              <Button
                className="btn border-btn outlined-btn btn-no"
                onClick={() => setShowViewModel(false)}
              >
                Cancel
              </Button>

              {formik.values._id ? (
                // <Button className="btn dark-btn btn-yes" type="submit">
                <Button className="btn btn-primary filled-btn" type="submit">
                  Update
                </Button>
              ) : (
                // <Button className="btn dark-btn btn-yes" type="submit">
                <Button className="btn btn-primary filled-btn" type="submit">
                  Create
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* delete patient modal */}
      <Modal
        className="dlt-patient-modal"
        show={deleteModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeleteModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this category</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no outlined-btn"
              onClick={() => setDeleteModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={() => _deleteCategory()}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
